import React from 'react';
import { Box, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';


const typing = keyframes`
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
`;

const TimeToGrowTypewriter = () => {
  return (
  
      <Box
  sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000000',
    height: '100vh',
    mt: {
      xs: 50,   // Extra-small screens (e.g. phones)
      sm: 50,  // Small screens (e.g. tablets)
      md: 50,  // Medium screens (e.g. small laptops)
      lg: 50,  // Large screens (e.g. desktops)
      xl: 50   // Extra-large screenss
    }
  }}
>
      <Typography
      component="h1"
  sx={{
    fontSize: { xs: '1.5rem', sm: '2rem', md: '3rem' }, // Responsive font size
    fontFamily: '"Times New Roman", Times, serif', // Apply Times New Roman font
    textAlign: 'center',
    letterSpacing: 7,
    overflow: 'hidden', // Hide the text before it is typed out
    whiteSpace: 'nowrap', // Prevent wrapping
    animation: `${typing} 4s steps(12) 1s forwards`, // Apply typing animation
    backgroundImage: "linear-gradient(45deg, #ffffff, #ffffff)",
    backgroundClip: "text", // Clips the background to the text
    color: "transparent",
  }}
>
  Time To Grow
</Typography>

     
    </Box>
  );
};

export default TimeToGrowTypewriter;
